module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Thêm mới dịch vụ",
      "breadcrumbs": [{
        title: 'Quản lý dịch vụ',
        route: {
          name: 'services'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "create-service-form",
    staticClass: "margin-top",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.localService,
      "label-width": "150px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validatorBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localService.name),
      callback: function($$v) {
        _vm.$set(_vm.localService, "name", $$v)
      },
      expression: "localService.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên viết tắt",
      "prop": "short_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên viết tắt"
    },
    model: {
      value: (_vm.localService.short_name),
      callback: function($$v) {
        _vm.$set(_vm.localService, "short_name", $$v)
      },
      expression: "localService.short_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Danh mục cha",
      "prop": "parent_id"
    }
  }, [_c('el-select', {
    class: ['width-100'],
    attrs: {
      "filterable": "",
      "placeholder": "Chọn danh mục cha"
    },
    model: {
      value: (_vm.localService.parent_id),
      callback: function($$v) {
        _vm.$set(_vm.localService, "parent_id", $$v)
      },
      expression: "localService.parent_id"
    }
  }, _vm._l((_vm.services), function(service, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": service.name,
        "value": service.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Icon",
      "prop": "icon"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "fa fa-font-awesome"
    },
    model: {
      value: (_vm.localService.icon),
      callback: function($$v) {
        _vm.$set(_vm.localService, "icon", $$v)
      },
      expression: "localService.icon"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Độ ưu tiên",
      "prop": "priority"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Độ ưu tiên"
    },
    model: {
      value: (_vm.localService.priority),
      callback: function($$v) {
        _vm.$set(_vm.localService, "priority", $$v)
      },
      expression: "localService.priority"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mô tả",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Mô tả"
    },
    model: {
      value: (_vm.localService.description),
      callback: function($$v) {
        _vm.$set(_vm.localService, "description", $$v)
      },
      expression: "localService.description"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-78edc0d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/NewService.vue
// module id = 721
// module chunks = 1